import script from "./ProgressEllipsis.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressEllipsis.vue?vue&type=script&setup=true&lang=ts"

import "./ProgressEllipsis.vue?vue&type=style&index=0&id=3350ca82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3350ca82"]])

export default __exports__